var scope_0 = require('/vercel/path0/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;export default
        Object.assign({}, scope_0 )
    